/**
 * Le fil du diagnostic — trois volets, une seule progression.
 *
 * Chaque écran annonçait son propre « Volet 0X » et rien d'autre : on savait où
 * on était, jamais combien il restait ni ce qui avait déjà été fait. Le parcours
 * se lisait comme trois questionnaires posés côte à côte plutôt que comme un
 * diagnostic en trois temps — au point que la fenêtre de paiement, elle, était
 * mieux jalonnée (« Étape 2 sur 3 ») que le diagnostic lui-même.
 *
 * Le fil est purement indicatif : il n'ouvre aucun raccourci. Chaque volet reste
 * accessible séparément, et rien n'oblige à les enchaîner.
 */

const VOLETS = ["Exposition", "Coût du temps", "Maîtrise"] as const;

export type Etape = 1 | 2 | 3;

export function Fil({ etape, fait = false }: { etape: Etape; fait?: boolean }) {
  return (
    <div className="fil" aria-label={`Volet ${etape} sur 3 — ${VOLETS[etape - 1]}`}>
      <span className="fil-rang">
        Volet <b>{etape}</b> sur 3
      </span>
      <ol>
        {VOLETS.map((nom, i) => {
          const rang = i + 1;
          // Le volet en cours reste « en cours » tant que son résultat n'est pas
          // affiché : c'est l'écran de résultat qui le marque terminé.
          const acheve = rang < etape || (rang === etape && fait);
          const courant = rang === etape && !fait;
          return (
            <li
              key={nom}
              className={acheve ? "fait" : courant ? "courant" : undefined}
              aria-current={courant ? "step" : undefined}
            >
              {nom}
            </li>
          );
        })}
      </ol>
    </div>
  );
}
